/* eslint-disable react-hooks/exhaustive-deps */
import LocalPrintshopOutlinedIcon from '@mui/icons-material/LocalPrintshopOutlined';
import { Page, Text, View, Document, StyleSheet, pdf, Font, Image } from "@react-pdf/renderer";
import dayjs from 'dayjs';
import { formatPrice } from '../../utils';
import { useTranslation } from 'react-i18next';
import Rudaw from '../../assets/fonts/rudawregular2.ttf';
import { useEffect, useState } from 'react';
import { CircularProgress } from '@mui/material';
import DriverService from '../../services/driverService';
import React from 'react';
import { useCompany } from '../../provider/companyProvider';
import { fileApiRoute } from "../../services/networkService";

const registerFont = () => {
    Font.register({
        family: 'Rudaw',
        fonts: [{ src: Rudaw, fontWeight: 'normal' }],
    });
};

const PdfDriverList = ({ data }) => {
    const { t, i18n } = useTranslation();
    const isRTL = i18n.language !== 'en';
    const [drivers, setDrivers] = useState([]);
    const [totalWallet, setTotalWallet] = useState(0);
    const [totalRemainingAmount, setTotalRemainingAmount] = useState(0);
    const [isLoading, setIsLoading] = useState(false);
    const { business } = useCompany();

    const styles = StyleSheet.create({
        page: {
            padding: 30,
            direction: isRTL ? 'rtl' : 'ltr',
            fontFamily: 'Rudaw',
        },
        title: {
            fontSize: 18,
            textAlign: "center",
            marginTop: 10,
            fontWeight: "bold",
        },
        infoSection: {
            marginBottom: 20,
            padding: 10,
            border: "1px solid #ccc",
            borderRadius: 5,
            fontSize: 14,
        },
        row: {
            flexDirection: isRTL ? 'row-reverse' : 'row',
            paddingVertical: 3,
            alignItems: 'center',
            direction: isRTL ? 'rtl' : 'ltr',
        },
        key: {
            fontWeight: 'bold',
            width: '40%',
            textAlign: isRTL ? 'right' : 'left',
            direction: isRTL ? 'rtl' : 'ltr',
        },
        value: {
            flex: 1,
            textAlign: isRTL ? 'right' : 'left',
            paddingLeft: 1,
        },
        table: {
            display: "table",
            width: "auto",
            borderWidth: 1,
            borderStyle: "solid",
            borderColor: "#ccc",
            marginBottom: 20,
        },
        tableRow: {
            flexDirection: isRTL ? "row-reverse" : "row",
        },
        tableCell: {
            flex: 1,
            padding: 5,
            borderRightWidth: 1,
            borderBottomWidth: 1,
            borderColor: "#ccc",
            textAlign: "center",
            fontSize: 10,
        },
        footer: {
            display: 'flex',
            flexDirection: isRTL ? 'row-reverse' : 'row',
            justifyContent: 'space-between',
            paddingVertical: 3,
            alignItems: 'center',
            direction: isRTL ? 'rtl' : 'ltr',
            textAlign: isRTL ? 'right' : 'left',
            fontSize: 12
        },
    });

    const MyDocument = () => {
        const { city, branch, supervisor, status } = data;

        return (
            <Document>
                <Page size="A4" style={styles.page}>
                    {/* Title */}
                    <View style={{ flexDirection: "row", alignItems: "center", justifyContent: "center", marginBottom: 4 }}>
                        <Image src={`${fileApiRoute}/${business.logo}`} style={{ width: 100, height: 50 }} />
                        <View style={{ width: 10 }}></View>
                        <Text style={styles.title}>{t('driverList')}</Text>
                    </View>

                    {/* Information Section */}
                    <View style={styles.infoSection}>
                        {city && (
                            <View style={styles.row}>
                                <Text style={styles.key}>{t('city')}:</Text>
                                <Text style={styles.value}>{city.name}</Text>
                            </View>
                        )}
                        {branch && (
                            <View style={styles.row}>
                                <Text style={styles.key}>{t('branch')}:</Text>
                                <Text style={styles.value}>{branch.name}</Text>
                            </View>
                        )}
                        {supervisor && (
                            <View style={styles.row}>
                                <Text style={styles.key}>{t('supervisor')}:</Text>
                                <Text style={styles.value}>{supervisor.name}</Text>
                            </View>
                        )}
                        {status && (
                            <View style={styles.row}>
                                <Text style={styles.key}>{t('status')}:</Text>
                                <Text style={styles.value}>{status}</Text>
                            </View>
                        )}
                        <View style={styles.row}>
                            <Text style={styles.key}>{t('currentDate')}:</Text>
                            <Text style={styles.value}>
                                {dayjs(new Date()).format('DD/MM/YYYY')}
                            </Text>
                        </View>
                    </View>

                    {/* Table */}
                    <View style={styles.table}>
                        {/* Table Header */}
                        <View style={[styles.tableRow, { backgroundColor: "#f0f0f0" }]}>
                            <Text style={styles.tableCell}>{t('name')}</Text>
                            <Text style={styles.tableCell}>{t('phone')}</Text>
                            <Text style={styles.tableCell}>{t('wallet')}</Text>
                            <Text style={styles.tableCell}>{t('remainAmount')}</Text>
                            <Text style={styles.tableCell}>{t('city')}</Text>
                            <Text style={styles.tableCell}>{t('branch')}</Text>
                            <Text style={styles.tableCell}>{t('supervisor')}</Text>
                            <Text style={styles.tableCell}>{t('status')}</Text>
                        </View>

                        {/* Table Rows */}
                        {drivers?.map((driver, index) => (
                            <View key={index} style={styles.tableRow}>
                                <Text style={styles.tableCell}>{driver.name}</Text>
                                <Text style={styles.tableCell}>{driver.phone}</Text>
                                <Text style={styles.tableCell}>{formatPrice(driver.wallet)}</Text>
                                <Text style={styles.tableCell}>{formatPrice(driver.remainAmount)}</Text>
                                <Text style={styles.tableCell}>{driver.city.name}</Text>
                                <Text style={styles.tableCell}>{driver.branch.name}</Text>
                                <Text style={styles.tableCell}>{driver.supervisor.name}</Text>
                                <Text style={styles.tableCell}>{t(driver.status)}</Text>
                            </View>
                        ))}
                    </View>

                    {/* Totals Section */}
                    <View style={styles.footer}>
                        <Text >{t('totalWallet')}: {formatPrice(totalWallet)}</Text>
                        <Text >{t('totalRemainingAmount')}: {formatPrice(totalRemainingAmount)}</Text>
                    </View>
                </Page>
            </Document>
        );
    };


    const handleStatus = (status) => {
        if (status === t("active")) return "active";
        else if (status === t("inactive")) return "inactive";
    };

    const fetchDrivers = async () => {
        try {
            setIsLoading(true);
            const filters = data && {
                name: data.name,
                branchId: data.branch && data.branch.id,
                cityId: data.city && data.city.id,
                supervisorId: data.supervisor && data.supervisor.id,
                status: handleStatus(data.status),
                deleted: data.deleted,
                sortBy: 'createdAt',
                order: 'asc'
            };

            const responseData = await DriverService.fetchAll(filters);

            setDrivers(responseData.drivers);
            setTotalWallet(responseData.totalWallet);
            setTotalRemainingAmount(responseData.totalRemainingAmount);
        } catch (error) {
            console.error("Failed to fetch drivers:", error);
        } finally {
            setIsLoading(false);
        }
    };

    const handlePrint = async () => {
        registerFont();
        await fetchDrivers();
    };

    useEffect(() => {
        if (drivers.length > 0) {
            (async () => {
                try {
                    const blob = await pdf(<MyDocument />).toBlob();
                    if (blob) {
                        const url = URL.createObjectURL(blob);
                        window.open(url);
                    } else {
                        console.error("Failed to generate PDF blob.");
                    }
                } catch (error) {
                    console.error("Error generating PDF:", error);
                }
            })();
        }
    }, [drivers]);

    return (
        // <PDFDownloadLink document={<MyDocument />} fileName="example.pdf">
        isLoading ? <CircularProgress size={28} /> :
            <LocalPrintshopOutlinedIcon sx={{ cursor: 'pointer' }} fontSize="medium" onClick={handlePrint} />
        // </PDFDownloadLink>
    );
}

export default PdfDriverList;